import React, {useState, useEffect, useRef} from 'react';

import {makeRequest} from "../../utils/httpRequest";

import Config from "../../core/config";

import {useRecoilState} from "recoil";

import {loadingAtom} from "../../atoms";

import WhatsAppButton from "../../core/WhatsAppButton";
import {buildDefaultWhatsAppMessage} from "../../utils/whatsappUtils";

import {useNavigate} from "react-router-dom";

import Loading from "../../core/Loading";

import {UserPermission} from "../../utils/utils";

import {usePermission} from "../../core/PermissionContext";

import NewButton from '../common/NewButton';

import TableRowActions from '../common/TableRowActions';

import ListPageLayout from '../common/ListPageLayout';
import { showConfirm } from '../../core/dialog';



const apiUrl = Config.apiUrl;



const CustomerList = () => {

    const { hasUserPermission, loadingPermissions } = usePermission();

    let [customers, setCustomers] = useState([]);

    const [queryString, setQueryString] = useState('');

    const inputQueryString = useRef(null);

    const [loading, setLoading] = useRecoilState(loadingAtom);

    const navigate = useNavigate();



    async function makeQuery(query) {

        try {

            setLoading(true);

            const url = apiUrl + '/api/customers/query=' + (query && query !== '' ? (query) : '');

            const response = await makeRequest(url, 'GET');

            setCustomers(response);

        } catch (error) {

            console.error('Error fetching data:', error);

        } finally {

            setLoading(false);

        }

    }



    useEffect(() => {

        if (inputQueryString.current) {

            inputQueryString.current.focus();

        }

        makeQuery('');

    }, []);



    async function deleteCustomer(id) {

        try {

            setLoading(true);

            const url = apiUrl + '/api/customers/' + id;

            await makeRequest(url, 'DELETE');

            await makeQuery(queryString);

        } catch (error) {

            console.error('Error fetching data:', error);

        } finally {

            setLoading(false);

        }

    }



    const handleInputChange = (e) => {

        const string = e.target.value;

        if (string.length >= 3 || string.length === 0) {

            makeQuery(string);

        }

        setQueryString(string);

    };



    const [sortConfig, setSortConfig] = useState({ key: 'name', direction: 'ascending' });



    const sortedCustomers = [...customers].sort((a, b) => {

        if (a[sortConfig.key] < b[sortConfig.key]) {

            return sortConfig.direction === 'ascending' ? -1 : 1;

        }

        if (a[sortConfig.key] > b[sortConfig.key]) {

            return sortConfig.direction === 'ascending' ? 1 : -1;

        }

        return 0;

    });



    const handleSort = (key) => {

        let direction = 'ascending';

        if (sortConfig.key === key && sortConfig.direction === 'ascending') {

            direction = 'descending';

        }

        setSortConfig({ key, direction });

    };



    const getSortIcon = (key) => {

        if (sortConfig.key === key) {

            return sortConfig.direction === 'ascending' ? '▲' : '▼';

        }

        return '';

    };



    if (loadingPermissions) {

        return <Loading></Loading>;

    }

    if (hasUserPermission(UserPermission.LIST_CUSTOMER) === false) {

        navigate('/unauthorizedaccess');

        return null;

    }



    return (

        <ListPageLayout

            tableWidth={580}

            header={

                <div style={{display: "flex", alignItems: "center", gap: '10px'}}>

                    <div className="header-label">Consulta de Clientes</div>

                    {hasUserPermission(UserPermission.CREATE_CUSTOMER) &&

                        <NewButton className={"new-button"} onClick={() => navigate('/app/customer')}/>

                    }

                </div>

            }

            filters={

                <div className="list-page-filters-field list-page-filters-query">

                    <input
                        ref={inputQueryString}
                        type="text"
                        className="list-page-filters-query-input"
                        value={queryString}
                        onChange={handleInputChange}
                    />

                </div>

            }

        >

            <table>

                <thead>

                <tr>

                    <th style={{ cursor:"pointer", minWidth:"100px" }} onClick={() => handleSort('code')}>

                        Código {getSortIcon('code')}

                    </th>

                    <th style={{ cursor:"pointer" }} onClick={() => handleSort('name')}>

                        Nome {getSortIcon('name')}

                    </th>

                    <th />

                </tr>

                </thead>

                <tbody>

                {sortedCustomers.map((customer, index) => (

                    <tr key={index}>

                        <td>

                            <div>{customer.code}</div>

                        </td>

                        <td>

                            <div>{customer.name}</div>

                        </td>

                        <td>

                            <TableRowActions

                                actions={[

                                    {
                                        key: 'whatsapp',
                                        label: 'WhatsApp',
                                        visible: !!customer.phone,
                                        phoneNumber: customer.phone,
                                        personName: customer.name,
                                        message: buildDefaultWhatsAppMessage(customer.name),
                                        render: () => (
                                            <WhatsAppButton
                                                phoneNumber={customer.phone}
                                                personName={customer.name}
                                            />
                                        ),
                                    },

                                    {

                                        key: 'edit',

                                        label: 'Editar',

                                        type: 'edit',

                                        visible: hasUserPermission(UserPermission.EDIT_CUSTOMER),

                                        onClick: () => navigate('/app/customer?id=' + customer.id),

                                        buttonProps: {'data-test': 'edit-button', className: 'edit-button'},

                                    },

                                    {

                                        key: 'delete',

                                        label: 'Excluir',

                                        type: 'delete',

                                        visible: hasUserPermission(UserPermission.REMOVE_CUSTOMER),

                                        onClick: async () => {

                                            if (await showConfirm('Deseja realmente excluir?')) {

                                                await deleteCustomer(customer.id);

                                            }

                                        },

                                        buttonProps: {'data-test': 'remove-button'},

                                    },

                                ]}

                            />

                        </td>

                    </tr>

                ))}

                </tbody>

                {customers.length === 0 && (<tfoot><tr><td colSpan="3">{loading ? 'Carregando...' : 'Nenhum item encontrado.'}</td></tr></tfoot>)}

            </table>

        </ListPageLayout>

    );

};



export default CustomerList;


